module.exports = __webpack_public_path__ + "static/hotfoil_small-21f45824c3babe50d35a32274ca152f5.jpg";